import ExternalApiRequest from "./../utils/ExternalApiRequest";
import actionTypes from "./../constants/actionTypes";
import { fetchFromCache, saveFormToCache } from "./../utils/utility";
import _ from "lodash"

export const getForms = (key1, key2, formKey1 = key1, formKey2 = key2, forceFetch = false) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const fetchFormList = [{ key: key1, formKey: formKey1 }, { key: key2, formKey: formKey2 }];


            const fetchFormFromApi = async (key) => {
                let options = {
                    api: "fetchForms",
                    urlAppend: key
                };
                let response = await ExternalApiRequest(options);
                const { payload = {} } = response;
                if (!_.isEmpty(payload))
                    await saveFormToCache(key, payload);
                return payload;
            }

            fetchFormList.map(async formMap => {
                const { key = '', formKey = '' } = formMap;
                if ((key && _.isEmpty(formJson[key])) || (forceFetch && key)) {
                    const cachedResponse = await fetchFromCache(key);

                    if (cachedResponse && !forceFetch) {
                        dispatch({
                            type: actionTypes.FORMS.FORM_FETCHED,
                            payload: cachedResponse,
                            formKey
                        });

                        // Keep UI fast with cache, but refresh cache/store in background.
                        fetchFormFromApi(key).then((latestFormJson) => {
                            if (!_.isEmpty(latestFormJson) && !_.isEqual(latestFormJson, cachedResponse)) {
                                dispatch({
                                    type: actionTypes.FORMS.FORM_FETCHED,
                                    payload: latestFormJson,
                                    formKey
                                });
                            }
                        }).catch((error) => {
                            console.log(error);
                        });
                        return;
                    }

                    const formJson = await fetchFormFromApi(key);
                    dispatch({
                        type: actionTypes.FORMS.FORM_FETCHED,
                        payload: formJson,
                        formKey
                    });
                }
            })

        };
    } catch (error) {
        console.log(error);
    }
};

export const getListFormJson = async (key) => {
    const options = {
        api: "fetchForms",
        urlAppend: key
    };
    const response = await ExternalApiRequest(options);
    const { payload = {} } = response;
    return payload;
}

export const getList = async (content, api, payloadKey, requestConfig = {}) => {
    const options = {
        api,
        content,
        ...requestConfig,
    };
    const response = await ExternalApiRequest(options);
    const { payload = {}, meta = {} } = response;
    if (payloadKey)
        return { [payloadKey]: payload[payloadKey] || [], meta };
    else
        return response;
}
